import React from 'react';
import {
  Dashboard,
  PatientInfo,
  Practice,
  Study,
  ECGCapture,
  EcgAnalyzeScreen,
  ConnectFacilityScreen,
  PPGScreen,
  PartnerConnect,
} from 'screens';
import { RoutePath } from 'types/enums';

export const ROUTES = [
  { path: RoutePath.ECG, element: <ECGCapture /> },
  { path: RoutePath.PPG, element: <PPGScreen /> },
  { path: RoutePath.PATIENT_DETAIL, element: <PatientInfo /> },
  { path: RoutePath.PRACTICE, element: <Practice /> },
  { path: RoutePath.DASHBOARD, element: <Dashboard /> },
  { path: RoutePath.STUDY, element: <Study /> },
  { path: RoutePath.ECG_ANALYZE, element: <EcgAnalyzeScreen /> },
  { path: RoutePath.CONNECT_FACILITY, element: <ConnectFacilityScreen /> },
  { path: RoutePath.PARTNER_CONNECT, element: <PartnerConnect /> },
  { path: RoutePath.ALL, element: <Dashboard /> },
];
